export default class UserSSO {

	constructor() {
		this.id = 0;
		this.userId = 0;
		this.oauthId = '';
		this.campaignSSOId = 0;
	}
}